import {
  ApolloLink,
  ApolloClient,
  InMemoryCache,
} from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';

let client;

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');

  return {
    headers: {
      ...headers,
      Authorization: token ? `JWT ${token}` : '',
    }
  }
});

const httpLink = createUploadLink({
  uri: process.env.REACT_APP_API_ENDPOINT,
  credentials: 'same-origin',
  fetch,
});

export function createApolloLink() {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DEMO === 'true') {
    const { isDemo } = require('./demo/isDemo');
    if (isDemo()) {
      const { demoLink } = require('./demo/demoLink');
      return demoLink;
    }
  }

  return ApolloLink.from([
    authLink,
    httpLink,
  ]);
}

export const createApolloClient = () => {
  if (!client) {
    client = new ApolloClient({
      link: createApolloLink(),
      cache: new InMemoryCache()
    });
  }

  return client;
 };
